import { v4 as uuid4 } from 'uuid';

 export const getUid = (): string => {
    // Check if a UUID already exists in localStorage
    let storedId = localStorage.getItem('uniqueId');
    if (!storedId) {
      // If not, generate a new one and save it to localStorage
      storedId = uuid4();
      localStorage.setItem('uniqueId', storedId);
    }
 
    return storedId;   
 };